function zendeskChatOnLogout() {
  const scriptElement = document.getElementById('ze-snippet');

  if (!scriptElement) return;

  window.zE?.('messenger', 'hide');
}

export { zendeskChatOnLogout };
